const  SignUp = () => import(/* webpackChunkName: "signup" */ 'Features/signup/Main');

export default {
  path: 'signup-old',
  component: SignUp,
  meta: {
    title: 'message.signUp'
  }
}
